import { Component, Input } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { IProcessStep, ProcessViewModel } from "@tylertech/tyler-api-types";
import { ProcessStepComponent } from "./processStep.component";
import { BusyIndicatorComponent } from "@tylertech/common-components-module";

@Component({
    selector: "processing-card",
    imports: [
        BusyIndicatorComponent,
        FlexLayoutModule,
        FlexModule,
        ProcessStepComponent,
    ],
    templateUrl: "./processingCard.tmpl.html",
    styleUrls: [
        "./processingCard.component.scss"
    ],
})
export class ProcessingCardComponent
{
    @Input()
    entity: ProcessViewModel;

    @Input()
    enableLink: boolean;

    isProcessing: boolean = false;

    get steps(): IProcessStep[]
    {
        return this.entity.Steps;
    }
}
